import { Fragment } from 'react'
import { Text } from '@chakra-ui/react'
import { NextSeo } from 'next-seo'
import { useTranslation } from 'next-i18next'

import NavigationBar from '@/components/NavigationBar'
import Footer from '@/components/Footer'
import { AlternateLink } from '@/components/AlternateLink'

import TermAndPrivacyLayout from '@/features/termsAndPrivacy/components/TermAndPrivacyLayout'
import { renderTemplate } from '@/features/termsAndPrivacy/helpers'
import { useTermsData } from '@/features/termsAndPrivacy/constants'

function TermsOfUse(): React.ReactElement {
  const { t } = useTranslation('termsAndPrivacy')

  const TERMS = useTermsData()

  return (
    <Fragment>
      <AlternateLink />
      <NextSeo title="Terms of Use" />
      <NavigationBar />
      <TermAndPrivacyLayout>
        <Text as="h1">{t('terms.title')}</Text>
        <Text>{t('terms.subtitle.0')}</Text>
        <Text>{t('terms.subtitle.1')}</Text>

        {renderTemplate(TERMS)}
        <br />
        <hr />
        <br />
        <Text id="end-content" sx={{ fontWeight: 'medium' }}>
          {t('terms.publishedDate')}
        </Text>
      </TermAndPrivacyLayout>
      <Footer />
    </Fragment>
  )
}

export default TermsOfUse
